module.exports = __webpack_public_path__ + "img/framework.751ce9e5.png";